__turbopack_context__.v({
  "collapsed": "Sidebar-module-scss-module__hXLuPW__collapsed",
  "header": "Sidebar-module-scss-module__hXLuPW__header",
  "inviteButton": "Sidebar-module-scss-module__hXLuPW__inviteButton",
  "logo": "Sidebar-module-scss-module__hXLuPW__logo",
  "navPanel": "Sidebar-module-scss-module__hXLuPW__navPanel",
  "navPanelNoIcons": "Sidebar-module-scss-module__hXLuPW__navPanelNoIcons",
  "navPanelWrapper": "Sidebar-module-scss-module__hXLuPW__navPanelWrapper",
  "panelContent": "Sidebar-module-scss-module__hXLuPW__panelContent",
  "sidebarNav": "Sidebar-module-scss-module__hXLuPW__sidebarNav",
  "toggleIcon": "Sidebar-module-scss-module__hXLuPW__toggleIcon",
  "wrapper": "Sidebar-module-scss-module__hXLuPW__wrapper",
});
